module.exports = __webpack_public_path__ + "static/image/help_more.svg?ab08757fc7f1d95488ddf9b86c8f575e";